import getImage from '../../../ClinicEvent/components/PdfReports/GetImage'
import pdfMake from 'pdfmake/build/pdfmake.js';
import moment from 'moment';
import 'moment-timezone';
import { calculateAgeParse } from '../../../../Utils/Patient'

const EpicrisisPDF = async (data) => {
    pdfMake.fonts = {
        OpenSans: {
            normal: 'OpenSans-Regular.ttf',
            bold: 'OpenSans-Bold.ttf',
            italics: 'OpenSans-Italic.ttf',
            bolditalics: 'OpenSans-ExtraBoldItalic.ttf'
        },
        Merriweather: {
            normal: 'Merriweather-Regular.ttf',
            bold: 'Merriweather-Bold.ttf',
            italics: 'Merriweather-Italic.ttf',
            bolditalics: 'Merriweather-ExtraBoldItalic.ttf'
        },
        Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Bold.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-BoldItalic.ttf'
        }
    };

    const urlLogo = sessionStorage.getItem('logoURL');

    let services = [];

    services.push([{ text: 'Procedimientos', style: 'tableheader', lineHeight: 1.2, }]);
    for (let obj of data.servicios) {
        services.push([{ text: obj.codigo + ' - ' + obj.nombre, style: 'textStyle', margin: [0, -8, 0, 0] }])
    }

    const header = {
        margin: [40, 10, 0, 0],
        layout: 'noBorders',
        table: {
            widths: ['*', '*'],
            body: [
                [{
                    image: await getImage(urlLogo),
                    fit: [100, 40],
                },
                {
                    text: data.profile.direccion.direccion +
                        " \n Teléfonos: " +
                        data.profile.telefono1 + " \n" + data.profile.nombre, style: 'head'
                }],

            ]
        },
    };

    const foter = (currentPage, pageCount) => {
        return {
            table: {
                widths: ['*', '*', '*'],
                body: [
                    [{ text: "Página " + currentPage.toString() + ' de ' + pageCount, style: 'foter' }, { text: name, style: 'foter' }, { text: 'Fecha Impresión: ' + moment().tz("America/Bogota").format("DD/MM/YYYY"), style: 'foter' }],
                ]
            },
            layout: 'noBorders',
            margin: [20, 0, 0, 5],
        };
    }

    const getTableNotes = () => {
        let tableEpicrisis = [];

        if(data.idEpicrisis == null){
            tableEpicrisis.push([{ text: "Epicrisis", style: "tableheader" }]);
        }
        else
        {
            tableEpicrisis.push([{ text: "Epicrisis", style: "tableheader" }]);
        }

        for(let i = 0; i < data.epicrisisList.length; i++)
        {
            if(data.idNota != null)
            {
                if(data.idNota == data.epicrisisList[i].id_hist_nota_clin)
                {
                    let item = [{ text: organizeNote(data.epicrisisList[i]), bold: false, style: "textStyle" }];
                    tableEpicrisis.push(item);
                }
            }
            else
            {
                let item = [{ text: organizeNote(data.epicrisisList[i]), bold: false, style: "textStyle" }];
                tableEpicrisis.push(item);
            }
    
        }
        return tableEpicrisis;
    }

    const organizeNote = (dataItem) => {
        let nota = `Autor: ${dataItem.nombre_usuario}\n`;
        nota = nota + `Fecha: ${moment(dataItem.fecha).format('DD-MM-YYYY')}\n\n`;
        nota = nota + `${dataItem.nota_clinica}\n\n`;
        return nota;
    }

    const documentDefinition = {
        pageSize: 'LETTER',
        pageOrientation: 'portrait',
        header: header,
        footer: foter,
        content: [
            {
                // auto-sized columns have their widths based on their content
                margin: [0, 20, 0, 10],
                layout: "headerLineOnly",
                table: {
                    headerRows: 1,
                    widths: ["auto", "*", "auto", "*"],
                    body: [
                        [{ text: "Datos del Paciente ", style: "tableheader" }, "", { text: 'Admisión: ' + data.admision, style: 'tableheader' }, { text: 'Fecha de Atención: ' + moment(data.patient.fecha_admision).format('DD-MM-YYYY'), style: 'tableheader' }],
                        [
                            { text: "Nombre ", bold: true, style: "textStyle" },
                            { text: data.patient.names, style: "textStyle" },
                            { text: "Identificación ", bold: true, style: "textStyle" },
                            { text: data.patient.typeOfDocument + '-' + data.patient.documentNumber, style: "textStyle" },
                        ],
                        [
                            { text: "Fecha de Nacimiento ", bold: true, style: "textStyle" },
                            { text: data.patient.birthday, style: "textStyle" },
                            { text: "Edad ", bold: true, style: "textStyle" },
                            { text: calculateAgeParse(data.patient.birthday), style: "textStyle" },
                        ],
                        [
                            { text: "Dirección ", bold: true, style: "textStyle" },
                            { text: data.patient.address, style: "textStyle" },
                            { text: "Ciudad ", bold: true, style: "textStyle" },
                            { text: data.patient.city, style: "textStyle" },
                        ],
                        [
                            { text: "Genero ", bold: true, style: "textStyle" },
                            { text: data.patient.gender, style: "textStyle" },
                            { text: "Tel/Cel: ", bold: true, style: "textStyle" },
                            { text: data.patient.telephone + '/' + data.patient.cellphone, style: "textStyle" }
                        ],
                    ],
                },
            },
            {
                // auto-sized columns have their widths based on their content                                       
                margin: [0, 0, 0, 10],
                layout: 'noBorders',
                table: {
                    widths: ['*'],
                    headerRows: 1,
                    body: services
                },
            },
            {
                margin: [0, 20, 0, 10],
                layout: "headerLineOnly",
                table: {
                    headerRows: 1,
                    widths: ["auto"],
                    body: getTableNotes(),
                },
            },
            {
                margin: [0, 10, 0, 0],
                text: '',
            },
        ],
        styles: {
            head: {
                fontSize: 7,
                bold: true,
                alignment: 'left',
                font: 'OpenSans'
            },
            tableheader: {
                fontSize: 9,
                bold: true,
                font: 'OpenSans'
            },
            textStyle: {
                fontSize: 9,
                font: 'OpenSans'
            },
            paragraf: {
                fontSize: 10,
                alignment: 'justify',
                font: 'OpenSans'
            },
            foter: {
                margin: 10,
                fontSize: 6,
                font: 'OpenSans'
            },
            medicStyle: {
                margin: [0, 80, 0, 0],
                fontSize: 10,
                alignment: 'left',
                font: 'OpenSans'
            }
        }
    };

    //pdfMake.createPdf(documentDefinition).open();
    const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
    pdfDocGenerator.getDataUrl(function (outDoc) {
        document.getElementById('pdfV').src = outDoc;
    });

}

export default EpicrisisPDF;
